import { Switch } from "antd";
import moment from "moment";

export const releaseDocumentsColumns = (
  navigate,
  handleSwitchToggle,
  switchStates = {},
  options = {},
) => [
  {
    title: "Document Name",
    dataIndex: "documentName",
    key: "documentName",
    width: 150,
  },
  {
    title: "Last updated",
    dataIndex: "modifiedAt",
    key: "modifiedAt",
    width: 135,
    render: (date) => {
      if (date) {
        return moment(date).format("YYYY-MM-DD");
      }
      return "-";
    },
  },
  {
    title: "Current Version",
    dataIndex: "currentVersion",
    key: "currentVersion",
    width: 135,
    align: "center",
    render: (version) => {
      return <div className="text-center">{`V.${version}`}</div>;
    },
  },
  {
    title: "Status",
    key: "status",
    width: 135,
    align: "center",
    dataIndex: "status",
    render: (_, record) => {
      const isActive =
        record.status &&
        (typeof record.status === "string"
          ? record.status.toUpperCase() === "ACTIVE"
          : !!record.status);

      return (
        <Switch
          className={`switches${options.isViewOnly ? " group-view-only-switch" : ""}`}
          checked={isActive}
          onChange={(checked) => handleSwitchToggle(record, checked)}
          disabled={options.isViewOnly}
        />
      );
    },
  },
  {
    title: "Action",
    key: "action",
    width: 135,
    align: "center",
    render: (_, record) => {
      if (!options.showView && !options.showManage) {
        return null;
      }

      const navigateToDocument = () =>
        navigate("/manage-release-document", {
          state: { documentData: record },
        });

      return (
        <div className="action-icons">
          <div>
            {options.showManage && (
              <button className="manage" onClick={navigateToDocument}>
                Manage
              </button>
            )}
            {options.showView && (
              <button className="manage" onClick={navigateToDocument}>
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
